import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {XauditModel} from '../xaudit.model';
import {DoctorDataModel} from './doctor-data.model';

export class DoctorSpecialtyDataModel extends XauditModel {
  DoctorId: string;
  DoctorSpecId: string;
  enumMedicalSpecialtyID: string;
  isPrimary: boolean;
  enumValidValueItem: EnumValidValueItemModel;
  dataDoctor: DoctorDataModel;
}
